'use strict';

var validator = require('validator');
var y = require('yup');
var ipAddress_utils = require('./ipAddress.utils.js');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const { isIpInRangeInclusive } = ipAddress_utils.ipUtils();
const name = 'ipAddress';
const IP_ADDRESS_ERROR = 'invalidIpAddress';
/**
 * Check is ip address is a multicast ip address (224.0.0.0 to 239.255.255.255).
 */ const isMultiCastIpAddress = (value)=>{
    return isIpInRangeInclusive(value, '224.0.0.0', '239.255.255.255');
};
/**
 * Check if ip address is a private ip address.
 */ const isPrivateIpAddress = (value)=>{
    const isClassA = isIpInRangeInclusive(value, '10.0.0.0', '10.255.255.255');
    const isClassB = isIpInRangeInclusive(value, '172.16.0.0', '172.31.255.255');
    const isClassC = isIpInRangeInclusive(value, '192.168.0.0', '192.168.255.255');
    return isClassA || isClassB || isClassC;
};
/**
 * Check if ip address is a loop back ip address (127.X.X.X).
 */ const isLoopbackIpAddress = (value)=>{
    return isIpInRangeInclusive(value, '127.0.0.0', '127.255.255.255');
};
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: IP_ADDRESS_ERROR
        },
        test: (value)=>{
            if (!value) {
                return true;
            }
            const hasRange = /\/\d*$/.test(value);
            const noRangeValue = value.replace(/\/\d*$/, '');
            if (isPrivateIpAddress(noRangeValue) || isLoopbackIpAddress(noRangeValue) || isMultiCastIpAddress(noRangeValue)) {
                return false;
            }
            if (options?.allowRange) {
                if (!validator.isIP(noRangeValue, '4')) {
                    return false;
                }
                if (hasRange && !validator.isIPRange(value, '4')) {
                    return false;
                }
            } else {
                // validate unmodified value.
                if (!validator.isIP(value, '4')) {
                    return false;
                }
            }
            return true;
        }
    });
});

exports.IP_ADDRESS_ERROR = IP_ADDRESS_ERROR;
//# sourceMappingURL=ipAddress.js.map
